import { Link } from 'react-router-dom';

interface ComingSoonProps {
  tier: 'Builders' | 'Inventors';
  age: string;
  emoji: string;
  blurb: string;
}

/**
 * Placeholder for not-yet-shipped tier routes (Builders Phase 2,
 * Inventors Phase 4). The URL exists so the tier picker can link to
 * something stable; the page just sets expectations for when the
 * tier actually arrives.
 */
export function ComingSoon({ tier, age, emoji, blurb }: ComingSoonProps): JSX.Element {
  return (
    <div className="grid min-h-dvh place-items-center bg-amber-50 px-4 py-6 sm:py-12">
      <div className="mx-auto max-w-md text-center">
        <span aria-hidden="true" className="text-7xl leading-none">
          {emoji}
        </span>
        <h1 className="mt-4 font-bold text-3xl text-slate-900 sm:text-4xl">{tier} — coming soon</h1>
        <p className="mt-2 text-base text-slate-500">{age}</p>
        <p className="mt-6 text-base text-slate-700">{blurb}</p>
        <p className="mt-8 text-slate-500 text-sm">
          We&rsquo;re shipping Explorers first.{' '}
          <Link to="/" className="text-amber-600 underline-offset-2 hover:underline">
            Try Explorers now →
          </Link>
        </p>
        <p className="mt-2 text-slate-400 text-xs">
          <Link to="/tier" className="underline-offset-2 hover:underline">
            ← Back to tier picker
          </Link>
        </p>
      </div>
    </div>
  );
}

export function BuildersComingSoon(): JSX.Element {
  return (
    <ComingSoon
      tier="Builders"
      age="Ages 8–10"
      emoji="🛠️"
      blurb="Multi-shape compositions, holes, rotations, plus real STL/3MF export tuned for school-friendly printers."
    />
  );
}

export function InventorsComingSoon(): JSX.Element {
  return (
    <ComingSoon
      tier="Inventors"
      age="Ages 11–12"
      emoji="🚀"
      blurb="Free-form shape authoring, parametric dimensions, real engineering moves. Brings 3D modeling closer to grown-up tools, kid-friendly."
    />
  );
}
